(function (angular) {
	'use strict';

	var investmentGoalSelectChartObject = {
		template: 
			'<div class="position-relative">' +
			'	<loader loading="investmentGoalSelect.chartLoading" gray="true"></loader>' +
			'	<div id="investment-goal-select-chart" ng-style="investmentGoalSelect.chartHeight"></div>' +
			'</div>',
		bindings: {
			data: '<',
			hideEarningsSeries: '<',
			customSeriesColor: '@?'
		},
		controller: [
			'$filter',
			'$window',
			'BREAKPOINTS',
			'investmentGoalFactory',
			'Highcharts',
			'HIGHCHARTS_OPTIONS',
			InvestmentGoalSelectFunction
		],
		controllerAs: 'investmentGoalSelect'
	};

	angular
		.module('investmentGoalChartModule')
		.component('investmentGoalSelectChart', investmentGoalSelectChartObject);

	function InvestmentGoalSelectFunction(
		$filter,
		$window,
		BREAKPOINTS,
		investmentGoalFactory,
		Highcharts,
		HIGHCHARTS_OPTIONS
	) {
		var investmentGoalSelect = this;
		var chart;
		var chartLineColor = "hsl(210,10%,90%)";
		var chartLabelColor = "hsl(210,5%,55%)";
		var baselineChartData;
		var updatedChartData;
		var chartSeriesColor;
		var earningsSeriesIsHidden = false;
		var higherSeries;
		var averageSeriesName = 'Projected average<br>account value<sup>1</sup>';
		var projectedSeriesName = 'Your account value goal';

		investmentGoalSelect.$onInit = function() {
			chartSeriesColor = angular.isDefined(investmentGoalSelect.customSeriesColor) ? investmentGoalSelect.customSeriesColor : '#F47735';
			investmentGoalSelect.chartHeight = $window.innerWidth < BREAKPOINTS.MD_START ? { 'height' : '200px' } : { 'height' : '300px' };
			investmentGoalSelect.chartLoading = true;

			Highcharts.setOptions(HIGHCHARTS_OPTIONS());
		};
		
		investmentGoalSelect.$onChanges = function(changesObj){
			if (angular.isDefined(investmentGoalSelect.data) && angular.isUndefined(chart)) {
				setChartData();
				initChart();
			} else if (angular.isDefined(investmentGoalSelect.data) && angular.isDefined(changesObj.data)) {
				updateSeriesData();
			}
		};

		function setChartData(){
			baselineChartData = investmentGoalFactory.getStandardChartSeries(investmentGoalSelect.data, 'date', 'averageInvestorAmount');
			updatedChartData = investmentGoalSelect.hideEarningsSeries ? [] : investmentGoalFactory.getStandardChartSeries(investmentGoalSelect.data, 'date', 'goalAmount');
			
			baselineChartData = addMarkersToLastPointInSeries(baselineChartData);
			
			if (investmentGoalSelect.hideEarningsSeries) {
				higherSeries = averageSeriesName;
			} else {
				higherSeries = baselineChartData[baselineChartData.length - 1].y > updatedChartData[updatedChartData.length - 1].y ? averageSeriesName : projectedSeriesName;
				updatedChartData = addMarkersToLastPointInSeries(updatedChartData);
			}
		}
		
		function updateSeriesData(){
			setChartData();
			
			var updatedChartSeries = getChartSeries();
			
			if (investmentGoalSelect.hideEarningsSeries) {
				earningsSeriesIsHidden = true;
				
				while (chart.series.length > 0) {
					chart.series[0].remove(true);
				}

				chart.addSeries(updatedChartSeries[0]);
				chart.addSeries(updatedChartSeries[1]);
			} else if (earningsSeriesIsHidden) {
				earningsSeriesIsHidden = false;
				
				chart.series[1].remove(true);
				chart.addSeries(updatedChartSeries[1]);
			} else {
				earningsSeriesIsHidden = false;

				chart.series[0].setData(baselineChartData);
				chart.series[1].setData(updatedChartData);
			}
		}

		function getChartSeries(){
			return [{
				name: averageSeriesName,
				type: 'line',
				color: '#878C92',
				data: baselineChartData,
				shadow: {
					color: '#878C92',
					offsetX: 3,
					offsetY: 3,
					opacity: 0.03,
					width: 9
				}
			}, {
				name: projectedSeriesName,
				type: 'line',
				color: chartSeriesColor,
				data: updatedChartData,
				shadow: {
					color: chartSeriesColor,
					offsetX: 3,
					offsetY: 3,
					opacity: 0.03,
					width: 9
				}
			}];
		}
		
		function initChart(){
			var chartSeries = getChartSeries();

			chart = new Highcharts.Chart({
				chart: {
					renderTo: 'investment-goal-select-chart',
					spacing: [0, 0, 0, 0]
				},
				plotOptions: {
					series: {
						dataLabels: {
							enabled: true,
							color: 'black',
							useHTML: true,
							crop: $window.innerWidth < BREAKPOINTS.MD_START,
							overflow: $window.innerWidth >= BREAKPOINTS.MD_START ? 'none' : 'justify',
							style: {
								fontSize: '24px',
								borderWidth: 0,
								textShadow: false
							},
							allowOverlap: true,
							formatter: function() {
								if(this.point.index === this.series.points.length - 1) {
									var roundedAmount =  $filter('roundToNearestValue')(this.y, 5000).toFixed(0);
									var formattedAmount = "<div>" + $filter('currency')(roundedAmount, '$', 0) + "</div>";
									var subtitle = "<div class='eta muted font-style-italic font-weight-normal'>" + this.series.name + "</div>";
									var topPositioning = higherSeries === this.series.name ? -75 : 25;
									var label = "<div class='module' style='padding: .5rem; position: absolute; border: 1px solid " + this.series.color + "; top: " + topPositioning + "px;'><div class='text-align-center'>" + formattedAmount + subtitle + "</div></div>";
									
									return label;
								}
							},
							x: -80
						},
						animation: {
							duration: 500
						},
						marker: {
							enabled: false
						},
						states: {
							hover: {
								enabled: false
							}
						},
						lineWidth: 3
					}
				},
				series: chartSeries,
				xAxis: {
					type: 'datetime'
				},
				yAxis: {
					endOnTick: false,
					gridLineColor: chartLineColor,
					labels: {
						formatter: function() {
							return '$' + Highcharts.numberFormat(this.value, 0);
						},
						style: {
							color: chartLabelColor
						}
					},
					startOnTick: false
				}
			}, function(){
				investmentGoalSelect.chartLoading = false;
			});
		}
		
		function addMarkersToLastPointInSeries(data){
			data[data.length - 1].marker = {
				enabled: true,
				radius: 5,
				symbol: 'circle'
			};
			
			return data;
		}
	}
})(window.angular);